import { Suspense, useContext, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import CheckInCheckOut from 'src/components/check-in-check-out';
import DailySessionNotes from 'src/components/dailySessionNotes';
import CreateDocumentPrview from 'src/components/document-management/create-document-preview';
import EditDocumentPreview from 'src/components/document-management/edit-document-preview';
import PreviewDocument from 'src/components/document-management/preview-document';
import SignatureTemplatePreview from 'src/components/document-management/signature-template-preview';
import DocumentErrorPage from 'src/components/ErrorHandling/DocumentErrorPage';
import ErrorPage from 'src/components/ErrorHandling/Error-page';
import NotPermission from 'src/components/ErrorHandling/NotPermission';
import LaborReportAndApproval from 'src/components/labor-report-and-approval';
import AuthorizationEditDetails from 'src/components/therapyPlanning/authorizationEditDetails';
import AuthorizationDetails from 'src/components/therapyPlanning/autorizationDetails';
import MDSAssessment from 'src/components/therapyPlanning/mdsAssessment';
import TherapyPlanningEditDetails from 'src/components/therapyPlanning/therapyPlanningEditDetails';
import { Layout as AuthLayout } from 'src/layouts/auth/classic-layout';
import { Layout as DashboardLayout } from 'src/layouts/dashboard';
import PostResetPassword from 'src/layouts/dashboard/post-reset-password/post-reset-password';
import ForgotPassWord from 'src/pages/auth/forgot-password';
import LandingPage from 'src/pages/auth/landing-page';
import Login from 'src/pages/auth/login';
import LogoutLanding from 'src/pages/auth/logout-landing';
import ResetPassword from 'src/pages/auth/reset-password';
import EditFacilityStayPage from 'src/pages/details-page/edit-facility-stay';
import PatientEpisodeOfcare from 'src/pages/details-page/episodeOfCare';
import EpisodeOfCareViewDetails from 'src/pages/details-page/episodeOfCareDetails';
import PatientDetails from 'src/pages/details-page/patient-details';
import PatientScreening from 'src/pages/details-page/patientScreening';
import EditScreeningDocumentPreview from 'src/pages/details-page/view-add-new-screen-form/edit-screening-document';
import ScreeningPreviewDocument from 'src/pages/details-page/view-add-new-screen-form/screening-preview-document';
import ViewAddNewScreenForm from 'src/pages/details-page/view-add-new-screen-form/view-add-new-screen-form';
import AddPatientForm from 'src/pages/forms/addPatientForm';
import PatientUpload from 'src/pages/patient-upload';
import Patients from 'src/pages/patients';
import RecentUploadedfiles from 'src/pages/recent-uploaded-files';
import MyAvailability from 'src/pages/schedule/my-availability';
// import TherapistSchedule as TherapistScheduleNewUI from 'src/pages/schedule/therapist/UI-Improvment/Therapist1';
import LaborHourManagement from 'src/components/labor-hour-managment/labor-hour-managmenent';
import PhysicianDashboard from 'src/components/physician/physician-dashboard';
import PhysicianDocumentsSign from 'src/components/physician/physician-documents-sign';
import MdsAssessmentUpload from 'src/components/therapyPlanning/mdsAssessmentUpload/mds-assessment-upload';
import TherapyPlanningDetails_2_0 from 'src/components/therapyPlanning_2.0/therapy-planing-details-2.0';
import TherapyPlanningInfo_2_0 from 'src/components/therapyPlanning_2.0/TherapyPlanningInfo-2.0';
import AddMdsCommunication from 'src/pages/details-page/mds-communication/add-mds-communication';
import EditMdsCommunication from 'src/pages/details-page/mds-communication/edit-mds-communication';
import MdsCommunication from 'src/pages/details-page/mds-communication/mds-communication';
import MdsCreateTable from 'src/pages/details-page/mds-communication/mds-create-table';
import SignMdsCommunication from 'src/pages/details-page/mds-communication/sign-mds-communication';
import ViewMdsCommunication from 'src/pages/details-page/mds-communication/view-mds-communication-form';
import PhysicianSignDocument from 'src/pages/details-page/Physician-Signature';
import { default as TherapistScheduleNewUI } from 'src/pages/schedule/therapist/UI-Improvment/Therapist1';
import Dashboard from 'src/pages/therapist-dashboard';
import TherapistDashboardDocEdit from 'src/pages/therapist-dashboard/therapist-document/therapist-dashboarb-doc-edit';
import TherapistDashboardDocPreview from 'src/pages/therapist-dashboard/therapist-document/therapist-dashboard-doc-preview';
import TherapistDashboardDocSignature from 'src/pages/therapist-dashboard/therapist-document/therapist-dashboard-doc-signature';
import { paths, permissions } from 'src/paths';
import {
  getAssignedFacilities,
  getTherapistProfileAction,
} from 'src/redux/actions/facilityActions';
import { getAllPatientsListResetAction } from 'src/redux/actions/patientAction';
import AddNewEpisodeOfCare from 'src/sections/dashboard/patients/addNewEpisodeOfCare';
import AddNewScreening from 'src/sections/dashboard/patients/addNewScreening';
import ScreeningDetails from 'src/sections/dashboard/patients/screeningDetails';
import DepartmentDashboard from 'src/sections/department-dashboard';
import { DeleteModal } from 'src/sections/modal/deleteModal';
import MonthDayAlert from 'src/sections/month-day-alert';
import MonthlyCloseoutAlert from 'src/sections/monthly-closeout-alert/monthly-closeout-alert';
import Reports from 'src/sections/reports';
import RestoreCare from 'src/sections/restore-care';
import RestoreSkill from 'src/sections/restore-skill';
import RestoreWellness from 'src/sections/restore-wellness';
import RedirectTab from 'src/utils/redirect-tab';
import AuthContext from './AuthContext';
import ErrorFallback from './ErroFallBack';
import PrivateRoute from './privateRoutes';
import PublicRoute from './publicRoutes';
import ServerErrorPage from './server-error';
import SignatureTemplatePreviewNew from 'src/components/document-management/signature-template-new';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { singleSignatureWorkflow } from 'src/config';
import DashboardDocSignaturePreviewNew from 'src/pages/therapist-dashboard/therapist-document/therapist-dashboar-doc-preview-new';
import { fetchAndLogPublicIP } from 'src/layouts/components/utils-method';
import SignatureTemplateWrapper from 'src/components/document-management/signature-template-wrapper';
import SignaturePreviewWrapper from 'src/pages/therapist-dashboard/therapist-document/signature-preview-wrapper';

function Router() {
  const {
    index,
    dashboard,dsn,
    patients,
    patientDetails,
    screening,
    episodeOfCare,
    createPatient,
    schedule,
    editFacilityStay,
    addNewScreening,
    addNewEpisodeOfCare,
    editPatient,
    sreeningDetails,
    details,
    editEpisodeOfCare,
    therapyPlanning,
    deactivate,
    facilityStay,
    addFacilityStay,
    landingPage,
    landingPageLogout,
    dailySessionNotes,
    previewDocument,
    editDocument,
    createDocument,
    getSignaturePreview,
    departmentDashboard,
    restoreSkill,
    monthDayAlert,
    restoreCare,
    restoreWellness,
    reports,
    laborManagement,
    redirectSupervisor,
    monthlyCloseoutAlert,
    mdsCommunication,
    addMdsCommunication,
    editMdsCommunication,
    viewMdsCommunication,
    signMds,
    evalMds,
    recertiMds,
    dischargeMds,
    physicianSign,
    physicianDashboard,
    physicianDocumentsSign,
  } = paths;

  const {
    READ_PATIENT,
    READ_DAILY_SESSION_NOTES,
    READ_DASHBOARD,
    READ_DEPARTMENT_DASHBOARD,
    READ_EPISODE_OF_CARE,
    READ_MONTH_END_ALERT,
    READ_MY_AVAILABILITY,
    READ_SCREENINGS,
    READ_THERAPIST_PLANNING,
    LABOR_MANAGEMENT,
    READ_THERAPIST_SCHEDULING,
  } = permissions;

  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const getAllPatientRes = useSelector((state: any) => state.getAllPatientListReducer);
  const dispatch = useDispatch();
  const checkHost = window.location.hostname;
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const pathName = window.location.pathname;
  const [isSingleSignatureWorkflow] = useFeatureToggleWhenReady(
    singleSignatureWorkflow,
    'ENTERPRISE'
  );

  useEffect(() => {
    const isLoggedIn = auth.authenticated;
    fetchAndLogPublicIP().then((res) => {
      localStorage.setItem('ip-address', res);
    });
    if (!isLoggedIn) return;
    const checkPageRefresh = () => {
      const navigationEntries: PerformanceNavigationTiming[] = window.performance.getEntriesByType(
        'navigation'
      ) as PerformanceNavigationTiming[];

      if (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') {
        dispatch(getTherapistProfileAction());
        dispatch(getAssignedFacilities());
      }
    };

    checkPageRefresh();
  }, []);

  useEffect(() => {
    const isLoggedIn = auth.authenticated;
    if (!isLoggedIn) return;
    if (!getAllPatientRes?.totalPatient?.length || !pathName?.split('/')?.[1]) {
      return;
    }
    if (pathName?.split('/')?.[1] !== 'patients') {
      dispatch(getAllPatientsListResetAction());
      return;
    }
  }, [pathName]);

  const currentPath = window?.location?.pathname?.split('/').filter(Boolean)?.pop();

  return (
    <Routes>
      <Route
        path={`${index}`}
        element={
          <PrivateRoute>
            <DashboardLayout>
              <ErrorBoundary
                fallback={<ErrorFallback />}
                key={
                  currentPath === 'error' || currentPath === 'document-error'
                    ? location.pathname
                    : null
                }
              >
                <Suspense>
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </DashboardLayout>
          </PrivateRoute>
        }
      >
        <Route
          path={checkHost === 'localhost' || checkHost === '127.0.0.1' ? '/:subdomain?' : '/'}
          element={<RedirectTab />}
        />

        <Route
          path={`${landingPage}/:realm?`}
          element={<LandingPage />}
        />

        <Route
          path={`/server-error`}
          element={<ServerErrorPage />}
        />

        <Route
          path={redirectSupervisor}
          element={<RedirectTab />}
        />

        {permissionData?.includes(READ_DASHBOARD) && (
          <Route
            path={dashboard}
            element={<Dashboard />}
          />
        )}

        {permissionData?.includes(READ_DEPARTMENT_DASHBOARD) && (
          <Route
            path={departmentDashboard}
            element={<DepartmentDashboard />}
          />
        )}

        <Route
          path={physicianDashboard}
          element={<PhysicianDashboard />}
        />
        <Route
          path={physicianDocumentsSign}
          element={<PhysicianDocumentsSign />}
        />

        <Route
          path={restoreSkill}
          element={<RestoreSkill />}
        />

        <Route
          path={'/error'}
          element={<ErrorPage />}
        />

        <Route
          path={'/document-error'}
          element={<DocumentErrorPage />}
        />

        {permissionData?.includes(READ_MONTH_END_ALERT) && (
          <Route
            path={monthDayAlert}
            element={<MonthDayAlert />}
          />
        )}

        {permissionData?.includes(READ_MONTH_END_ALERT) && (
          <Route
            path={monthlyCloseoutAlert}
            element={<MonthlyCloseoutAlert />}
          />
        )}

        <Route
          path={restoreCare}
          element={<RestoreCare />}
        />
        <Route
          path={restoreWellness}
          element={<RestoreWellness />}
        />
        <Route
          path={reports}
          element={<Reports />}
        />

        {permissionData?.includes(READ_DAILY_SESSION_NOTES) && (
          <Route
            path={dailySessionNotes}
            element={<DailySessionNotes />}
          />
        )}

        <Route
          path={`/physician-dashboard/doc-sign`}
          element={<TherapistDashboardDocSignature />}
        />
        <Route
          path={`${dashboard}/doc-sign`}
          element={<SignaturePreviewWrapper />}
        />
        <Route
          path={`/dashboard/doc`}
          element={<TherapistDashboardDocPreview />}
        />
        <Route
          path={`/physician-dashboard/doc`}
          element={<TherapistDashboardDocPreview />}
        />
        <Route
          path="/document/document-edit"
          element={<TherapistDashboardDocEdit />}
        />

        {permissionData?.includes(READ_PATIENT) && (
          <>
            <Route
              path={patients}
              element={<Patients />}
            />
            <Route
              path={`${patients}/${createPatient}`}
              element={<AddPatientForm action={'Create'} />}
            />
            <Route
              path={`${patients}${editPatient}`}
              element={<AddPatientForm action={'Edit'} />}
            />

            <Route
              path={`${patients}/upload`}
              element={<PatientUpload />}
            />
            <Route
              path={`${patients}/recent-uploaded`}
              element={<RecentUploadedfiles />}
            />
            {permissionData?.includes(READ_SCREENINGS) && (
              <>
                <Route
                  path={`${patients}/${patientDetails}${screening}${addNewScreening}`}
                  element={<AddNewScreening />}
                />
                <Route
                  path={`${patients}/${patientDetails}${screening}/view-form`}
                  element={<ViewAddNewScreenForm />}
                />
                <Route
                  path={`${patients}/${patientDetails}${screening}/view-document`}
                  element={<ScreeningPreviewDocument />}
                />
                <Route
                  path={`${patients}/${patientDetails}${screening}/view-edit-document`}
                  element={<EditScreeningDocumentPreview />}
                />
              </>
            )}
            {permissionData?.includes(READ_EPISODE_OF_CARE) && (
              <>
                <Route
                  path={`${patients}/${patientDetails}${episodeOfCare}${addNewEpisodeOfCare}`}
                  element={<AddNewEpisodeOfCare action="Create" />}
                />
                <Route
                  path={`${patients}/${patientDetails}${episodeOfCare}${editEpisodeOfCare}`}
                  element={<AddNewEpisodeOfCare action="Edit" />}
                />
                <Route
                  path={`${patients}/${patientDetails}${episodeOfCare}${details}`}
                  element={<EpisodeOfCareViewDetails />}
                />
              </>
            )}
          </>
        )}

        {/* {permissionData?.includes(READ_MY_AVAILABILITY) && ( */}
        <Route path={laborManagement.index}>
          {permissionData?.includes(READ_MY_AVAILABILITY) && (
            <Route
              path={laborManagement.myAvailability}
              element={<MyAvailability />}
            />
          )}
          <Route
            path={laborManagement.checkInCheckOut}
            element={<CheckInCheckOut />}
          />
          <Route
            path={laborManagement.laborReportAndApproval}
            element={<LaborReportAndApproval />}
          />
          {permissionData?.includes(LABOR_MANAGEMENT) && (
            <Route
              path={laborManagement.laborHoursManagement}
              element={<LaborHourManagement />}
            />
          )}
        </Route>

        {permissionData?.includes(READ_THERAPIST_SCHEDULING) && (
          <Route path={schedule.index}>
            <Route
              path={schedule.therapistSchedule}
              element={<TherapistScheduleNewUI />}
            />
          </Route>
        )}

        <Route
          path={`${patients}/${patientDetails}${episodeOfCare}${details}${previewDocument}`}
          element={<PreviewDocument />}
        />
        <Route
          path={`${patients}/${patientDetails}${episodeOfCare}${details}${editDocument}`}
          element={<EditDocumentPreview />}
        />
        <Route
          path={`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`}
          element={<CreateDocumentPrview />}
        />
        <Route
          path={`${patients}/${patientDetails}${episodeOfCare}${details}${physicianSign}`}
          element={<PhysicianSignDocument />}
        />
        <Route
          path={`${patients}/${patientDetails}${episodeOfCare}${details}${getSignaturePreview}`}
          element={<SignatureTemplateWrapper />}
        />

        <Route
          path={`${patients}/${deactivate}`}
          element={<DeleteModal />}
        ></Route>
        {permissionData?.includes(READ_PATIENT) && (
          <>
            <Route
              path={`${patients}/${facilityStay}/${addFacilityStay}`}
              element={<EditFacilityStayPage />}
            ></Route>

            <Route
              path={`${patients}/${patientDetails}${screening}${sreeningDetails}`}
              element={<ScreeningDetails />}
            />
            <Route
              path={`${patients}/${patientDetails}`}
              element={<PatientDetails />}
            >
              {permissionData?.includes(READ_SCREENINGS) && (
                <Route
                  path={`${patients}/${patientDetails}${screening}`}
                  element={<PatientScreening />}
                ></Route>
              )}
              {permissionData?.includes(READ_EPISODE_OF_CARE) && (
                <Route
                  path={`${patients}/${patientDetails}${episodeOfCare}`}
                  element={<PatientEpisodeOfcare />}
                />
              )}
              <Route
                path={`${patients}/${patientDetails}${mdsCommunication}`}
                element={<MdsCommunication />}
              />
              {[
                `${patients}/${patientDetails}${mdsCommunication}${evalMds}`,
                `${patients}/${patientDetails}${mdsCommunication}${recertiMds}`,
                `${patients}/${patientDetails}${mdsCommunication}${dischargeMds}`,
              ].map((item) => {
                return (
                  <Route
                    path={item}
                    element={<MdsCreateTable />}
                  />
                );
              })}
            </Route>
            <Route
              path={`${patients}/${patientDetails}${mdsCommunication}${addMdsCommunication}`}
              element={<AddMdsCommunication />}
            />
            <Route
              path={`${patients}/${patientDetails}${mdsCommunication}${editMdsCommunication}`}
              element={<EditMdsCommunication />}
            />
            <Route
              path={`${patients}/${patientDetails}${mdsCommunication}${viewMdsCommunication}`}
              element={<ViewMdsCommunication />}
            />
            <Route
              path={`${patients}/${patientDetails}${mdsCommunication}${signMds}`}
              element={<SignMdsCommunication />}
            />
          </>
        )}

        <Route
          path={`${patients}/${patientDetails}${editFacilityStay}`}
          element={<EditFacilityStayPage />}
        />
        <Route
          path={`${'/scheduling/therapy-planning'}/upload`}
          element={<MdsAssessmentUpload />}
        />

        {/* old code of therapy planning */}

        {/* {permissionData?.includes(READ_THERAPIST_PLANNING) && (
          <>
           
            <Route
              path={`${therapyPlanning.index}${therapyPlanning.details}`}
              element={<TherapyPlanningDetails />}
            >
            
              <Route
                index
                element={<MDSAssessment />}
              />
            
              <Route
                path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`}
                element={<TherapyPlanningInfo />}
              />
              
              <Route
                path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`}
                element={<AuthorizationDetails />}
              />
            </Route>
            <Route
              path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editAuthorization}`}
              element={<AuthorizationEditDetails />}
            />

            <Route
              path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`}
              element={<TherapyPlanningEditDetails />}
            />
          </>
        )} */}

        {/* new code of therapy planning 2.0 */}

        {permissionData?.includes(READ_THERAPIST_PLANNING) && (
          <>
            <Route
              path={`${therapyPlanning.index}${therapyPlanning.details}`}
              element={<TherapyPlanningDetails_2_0 />}
            >
              <Route
                index
                element={<MDSAssessment />}
              />

              <Route
                path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`}
                element={<TherapyPlanningInfo_2_0 />}
              />
              <Route
                path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`}
                element={<AuthorizationDetails />}
              />
            </Route>

            <Route
              path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editAuthorization}`}
              element={<AuthorizationEditDetails />}
            />

            <Route
              path={`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`}
              element={<TherapyPlanningEditDetails />}
            />
          </>
        )}
        <Route
          path="*"
          element={<NotPermission />}
        />
      </Route>

      {/* post reset password */}

      <Route
        path={index}
        element={
          <PrivateRoute>
            <AuthLayout>
              <Suspense>
                <Outlet />
              </Suspense>
            </AuthLayout>
          </PrivateRoute>
        }
      >
        <Route
          path="/post-auth-forgot-password"
          element={<PostResetPassword />}
        />
      </Route>

      {/* Public Routes */}
      <Route
        path={'auth'}
        element={
          <PublicRoute>
            <AuthLayout>
              <Suspense>
                <Outlet />
              </Suspense>
            </AuthLayout>
          </PublicRoute>
        }
      >
        <Route
          path="login"
          element={<Login />}
        />
        <Route
          path="forgot-password"
          element={<ForgotPassWord />}
        />
        <Route
          path="reset-password"
          element={<ResetPassword />}
        />
        <Route
          path={landingPageLogout}
          element={<LogoutLanding />}
        />
      </Route>
    </Routes>
  );
}

export default Router;
